import React, { FC } from 'react';
import { Route } from 'react-router-dom';
import useRolePermissions from '../hook/useRolePermissions';
import NotFoundPage from '../pages/DefaultPages/NotFoundPage';
import loadableRoutes from './loadableRoutes';
import { ConnectedSwitch } from './reactRouterConnected';

const Routes: FC = () => {
  // useEffect(() => {
  //   const timeoutId = setTimeout(
  //     () => Object.keys(loadableRoutes).forEach((path) => loadableRoutes[path].component.preload()),
  //     10, // load after 5 sec
  //   );
  //
  //   return () => clearTimeout(timeoutId);
  // }, []);

  const { hasAnyPermission } = useRolePermissions();

  return (
    <ConnectedSwitch>
      {
        Object.keys(loadableRoutes)
          .filter((path) => {
            const { permissions = [] } = loadableRoutes[path];
            return !permissions.length || hasAnyPermission(...permissions);
          })
          .map((path) => {
            let { exact = true } = loadableRoutes[path];
            const { component: WrappedComponent, ...routeProps } = loadableRoutes[path];
            exact = !!exact; // set true as default
            const WrapperComponent: FC = (props: any) => (
              <WrappedComponent {...routeProps} {...props} />
            );
            return <Route key={path} path={path} exact={exact} component={WrapperComponent} />;
          })
      }
      <Route render={() => <NotFoundPage />} />
    </ConnectedSwitch>
  );
};

export { loadableRoutes };
export default Routes;
